import { render } from "./WebshopProductOptions.vue?vue&type=template&id=4a0cce47"
import script from "./WebshopProductOptions.vue?vue&type=script&lang=js"
export * from "./WebshopProductOptions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__